import React, { Fragment, useState, useEffect, useCallback } from "react";

import List from "../../components/notification-message/List";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const NotificationMessage = (props) => {
  const [error, setError] = useState(null);

  const title = "ข้อความแจ้งเตือน";

  let content = <List />;

  if (error) {
    content = <p>{error}</p>;
  }

  return (
    <>
      <nav aria-label="breadcrumb">
        <ol id="w9" className="breadcrumb container py-2 mb-0 px-3">
          <li className="breadcrumb-item">
            <Link to="/">
              <FontAwesomeIcon icon={faHome} />
            </Link>
          </li>
          <li
            className="breadcrumb-item active font-sarabun"
            aria-current="page"
          >
            ข้อความแจ้งเตือน
          </li>
        </ol>
      </nav>
      {content}
    </>
  );
};

export default NotificationMessage;
